/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ShapeStandingList } from '../models/ShapeStandingList';
import type { StandingAll } from '../models/StandingAll';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StandingService {
    /**
     * Get Standing By League
     * @param leagueId
     * @returns StandingAll Successful Response
     * @throws ApiError
     */
    public static getStandingByLeagueStandingLeagueLeagueIdGet(
        leagueId: number,
    ): CancelablePromise<StandingAll> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/standing/league/{league_id}',
            path: {
                'league_id': leagueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Standing History Of Team
     * @param teamId
     * @param leagueId
     * @param amountMatchDays
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getStandingHistoryOfTeamStandingHistoryTeamTeamIdGet(
        teamId: number,
        leagueId: number,
        amountMatchDays: number = 5,
    ): CancelablePromise<Record<string, number>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/standing/history/team/{team_id}',
            path: {
                'team_id': teamId,
            },
            query: {
                'league_id': leagueId,
                'amount_match_days': amountMatchDays,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Standing With Shape
     * @param league
     * @returns ShapeStandingList Successful Response
     * @throws ApiError
     */
    public static getStandingWithShapeStandingShapeLeagueLeagueGet(
        league: number,
    ): CancelablePromise<ShapeStandingList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/standing/shape/league/{league}',
            path: {
                'league': league,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
